import React from "react";

import {
    FaRocket,
    FaChartLine,
    FaBolt,
    FaCloud
} from "react-icons/fa";

import MainPage         from './../pictures/MainTable_2.PNG' ;


class LiveTradingCard extends React.Component {


    openTrading = () => {


        /*
            Later replace with your real route:

            this.props.history.push("/trading")

            or

            window.location.href="/trading"

        */


        console.log("Opening Live Trading");


    };




    render(){


        return (




            <div className="idms-card live-trading-card"  className="shadow" style={{ backgroundImage:  'url("./pictures/background_7.jpg")' }} >



                <div className="card-header">


                    <div>


                        <h2 className="card-title">

                            Live Trading Platform

                        </h2>


                        <p className="card-subtitle">

                            Access real-time AI trading intelligence

                        </p>


                    </div>



                    <FaRocket

                        className="header-icon"

                    />


                </div>





                <div className="live-status-container">





                    <div className="live-status-item">


                        <FaCloud />


                        <div>

                            <span>

                                Cloud Connection

                            </span>


                            <strong className="online-text">

                                Connected

                            </strong>


                        </div>


                    </div>




                    <div className="live-status-item">


                        <FaBolt />


                        <div>

                            <span>

                                AI Engine

                            </span>


                            <strong className="online-text">

                                Running

                            </strong>


                        </div>


                    </div>





                    <div className="live-status-item">


                        <FaChartLine />


                        <div>

                            <span>

                                Market Signals

                            </span>


                            <strong>

                                Available

                            </strong>


                        </div>


                    </div>



                </div>



               


                                
               {/*<div className="platform-features">

                    <div className="feature-card">

                        <div className="feature-icon">
                            🧠
                        </div>

                        <div className="feature-content">
                            <h4>AI Signal Engine</h4>
                            <p>Machine learning market analysis</p>
                        </div>

                    </div>


                    <div className="feature-card">

                        <div className="feature-icon">
                            📊
                        </div>

                        <div className="feature-content">
                            <h4>Live Charts</h4>
                            <p>Real-time market visualization</p>
                        </div>

                    </div>


                        <div className="feature-card">

                            <div className="feature-icon">
                                🔔
                            </div>

                            <div className="feature-content">
                                <h4>Trading Alerts</h4>
                                <p>Actionable signal notifications</p>
                            </div>

                        </div>


                        <div className="feature-card">

                            <div className="feature-icon">
                                ⚡
                            </div>

                            <div className="feature-content">
                                <h4>MT5 Integration</h4>
                                <p>Automated trading connection</p>
                            </div>

                        </div>


                    </div>*/}





                <div className="live-trading-container">


                    <button


                        className="live-trading-button"


                        onClick={
                            this.openTrading
                        }


                    >


                        <FaRocket />


                        &nbsp;


                        Open Live Trading



                    </button>

                    <br></br>
                    <br></br>


                    
                     <img
                    //src="/images/idms-platform-preview.png"
                    src={MainPage}  
                    height= "300px" width="100%"
                    alt="iDMS"
                    alt="iDMS Platform"
                    ></img>



                  
               <div className="platform-features">

                    <div className="feature-card">

                        <div className="feature-icon">
                            🧠
                        </div>

                        <div className="feature-content">
                            <h4>AI Signal Engine</h4>
                            <p>Machine learning market analysis</p>
                        </div>

                    </div>


                    <div className="feature-card">

                        <div className="feature-icon">
                            📊
                        </div>

                        <div className="feature-content">
                            <h4>Live Charts</h4>
                            <p>Real-time market visualization</p>
                        </div>

                    </div>


                        <div className="feature-card">

                            <div className="feature-icon">
                                🔔
                            </div>

                            <div className="feature-content">
                                <h4>Trading Alerts</h4>
                                <p>Actionable signal notifications</p>
                            </div>

                        </div>


                        <div className="feature-card">

                            <div className="feature-icon">
                                ⚡
                            </div>

                            <div className="feature-content">
                                <h4>MT5 Integration</h4>
                                <p>Automated trading connection</p>
                            </div>

                        </div>


                    </div>









                </div>











            </div>


        );


    }


}



export default LiveTradingCard;